export const PlaceCategoryArray = [
  "restaurant",
  "health-care",
  "medical",
  "beauty-spas",
  "transportation",
  "public-places",
  "shop",
  "art",
  "evacuation-center",
  "polling-place",
  "tourist-attraction",
  "toilet",
  "entertainment",
  "disaster-prevention",
] as const;
